import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" className="font-heading text-3xl text-[#D4AF37] tracking-wider">LUXIFER 6</Link>
          <p className="text-white/40 text-sm mt-2 uppercase tracking-wider">Reset Password</p>
        </div>

        {sent ? (
          <div data-testid="forgot-password-success" className="text-center space-y-4">
            <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mx-auto">
              <Mail className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <p className="text-white/60 text-sm">If this email is registered, a password reset link has been sent to your inbox. Check your email (including spam folder).</p>
            <Link to="/admin/login" className="text-sm text-[#D4AF37] hover:underline block mt-4">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <p className="text-white/50 text-sm">Enter your admin email to receive a password reset link.</p>
            <div>
              <label className="text-xs uppercase tracking-wider text-white/40 mb-2 block">Email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="w-full bg-[#111111] border border-white/10 focus:border-[#D4AF37] outline-none p-3 text-white placeholder:text-white/20 rounded transition-colors"
              />
            </div>
            <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full bg-[#D4AF37] text-black hover:bg-white font-semibold py-3 uppercase tracking-wider text-sm h-auto">
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>
            <div className="text-center">
              <Link to="/admin/login" className="text-sm text-white/40 hover:text-white/60">Back to Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
